<app-tagline></app-tagline>
<app-navbar [navClass]="'defaultscroll is-sticky tagline-height'" [navLight]="true"></app-navbar>

<section class="relative md:pt-44 md:pb-32 py-18 table w-full items-center bg-[url('/assets/images/bg/1_new.jpg')] bg-top bg-no-repeat bg-cover">
  <div class="absolute inset-0 bg-slate-900/40"></div>
  <div class="container relative">
    <div class="flex items-center justify-between gap-[10px] lg:m-0 md:m-0 mt-20">
      <div class="lg:col-span-8 md:col-span-7 md:order-1 order-2">
        <h5 class="text-3xl font-dancing text-white">Find Your Perfect Stay</h5>
        <h4 class="font-bold text-white lg:leading-normal leading-normal text-4xl lg:text-6xl mb-6 mt-5">Discover Your Amazing Smart Cozy Stay in Germany</h4>
        <p class="text-white/70 text-xl max-w-xl">Book unique homes, apartments, and vacation rentals for your perfect getaway. Experience comfort and convenience with our curated selection of properties.</p>
      </div>

      <div class="lg:col-span-2 md:col-span-2 md:text-center md:order-2 order-1">
        <a
          routerLink="#!"
          data-type="youtube"
          data-id="S_CGed6E610"
          data-modal-target="default-modal"
          data-modal-toggle="default-modal"
          class="lightbox lg:h-24 h-20 lg:w-24 w-2 rounded-full shadow-lg dark:shadow-gray-800 inline-flex items-center justify-center bg-white hover:bg-red-500 text-red-500 hover:text-white duration-500 ease-in-out mx-auto"
        >
          <i class="mdi mdi-play inline-flex items-center justify-center text-3xl"></i>
        </a>
      </div>

      <div
        id="default-modal"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
      >
        <div class="video-container">
          <iframe
            src="https://www.youtube.com/embed/S_CGed6E610"
            class="md:w-[640px] md:h-[360px] w-[350px] h-[250px]"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container relative -mt-16 z-1">
  <app-form></app-form>
</div>

<!-- Online Check-In Call-to-Action -->
<section class="relative py-16">
  <div class="container relative">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
      <div>
        <div class="p-8 bg-gradient-to-r from-red-500 to-red-600 rounded-xl text-white">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-4">
              <i data-feather="smartphone" class="w-6 h-6"></i>
            </div>
            <h3 class="text-2xl font-semibold">Already Booked?</h3>
          </div>
          <p class="text-lg opacity-90 mb-6">
            Skip the front desk and check in online! Get your room access code instantly and enjoy a seamless arrival experience.
          </p>
          <div class="flex flex-col sm:flex-row gap-4">
            <a
              [routerLink]="'/online-check-in'"
              class="inline-flex items-center justify-center px-6 py-3 bg-white text-red-600 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200">
              <i data-feather="smartphone" class="w-5 h-5 mr-2"></i>
              Start Online Check-In
            </a>
            <a
              [routerLink]="'/online-check-in'"
              class="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white rounded-lg font-medium hover:bg-white hover:text-red-600 transition-colors duration-200">
              <i data-feather="info" class="w-5 h-5 mr-2"></i>
              Learn More
            </a>
          </div>
        </div>
      </div>

      <div class="text-center lg:text-left">
        <h4 class="text-3xl font-semibold text-gray-900 dark:text-white mb-4">
          Contactless Check-In Experience
        </h4>
        <p class="text-gray-600 dark:text-gray-400 text-lg mb-6">
          Our online check-in process is designed for your convenience and safety. Complete your check-in from anywhere, anytime.
        </p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="flex items-center">
            <div class="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mr-3">
              <i data-feather="check" class="w-4 h-4 text-green-600"></i>
            </div>
            <span class="text-gray-700 dark:text-gray-300">ID Verification</span>
          </div>
          <div class="flex items-center">
            <div class="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mr-3">
              <i data-feather="check" class="w-4 h-4 text-green-600"></i>
            </div>
            <span class="text-gray-700 dark:text-gray-300">QR Access Codes</span>
          </div>
          <div class="flex items-center">
            <div class="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mr-3">
              <i data-feather="check" class="w-4 h-4 text-green-600"></i>
            </div>
            <span class="text-gray-700 dark:text-gray-300">24/7 Available</span>
          </div>
          <div class="flex items-center">
            <div class="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mr-3">
              <i data-feather="check" class="w-4 h-4 text-green-600"></i>
            </div>
            <span class="text-gray-700 dark:text-gray-300">Secure & Fast</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Smart Lock & QR Code Info Section -->
<section class="relative py-16 bg-gray-50 dark:bg-gray-900">
  <div class="container relative">
    <div class="grid grid-cols-1 text-center mb-12">
      <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold text-gray-900 dark:text-white">
        Keyless Entry with Smart Lock Technology
      </h3>
      <p class="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto text-lg">
        Experience the future of accommodation access with our advanced QR code smart lock system.
        Secure, convenient, and completely contactless.
      </p>
    </div>

    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
      <!-- QR Code Access -->
      <div class="text-center p-6 bg-white dark:bg-slate-800 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
        <div class="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
          <i data-feather="smartphone" class="w-8 h-8 text-blue-600"></i>
        </div>
        <h4 class="text-xl font-semibold text-gray-900 dark:text-white mb-3">QR Code Access</h4>
        <p class="text-gray-600 dark:text-gray-400 mb-4">
          Simply scan the QR code with your smartphone to unlock your accommodation instantly. No physical keys needed.
        </p>
        <div class="flex items-center justify-center text-sm text-blue-600 dark:text-blue-400">
          <i data-feather="check-circle" class="w-4 h-4 mr-2"></i>
          <span>Instant Access</span>
        </div>
      </div>

      <!-- Smart Lock Technology -->
      <div class="text-center p-6 bg-white dark:bg-slate-800 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
        <div class="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
          <i data-feather="lock" class="w-8 h-8 text-green-600"></i>
        </div>
        <h4 class="text-xl font-semibold text-gray-900 dark:text-white mb-3">Smart Lock System</h4>
        <p class="text-gray-600 dark:text-gray-400 mb-4">
          Our advanced smart locks provide secure, encrypted access that activates automatically before your check-in time.
        </p>
        <div class="flex items-center justify-center text-sm text-green-600 dark:text-green-400">
          <i data-feather="shield" class="w-4 h-4 mr-2"></i>
          <span>High-Level Security</span>
        </div>
      </div>

      <!-- 24/7 Availability -->
      <div class="text-center p-6 bg-white dark:bg-slate-800 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
        <div class="w-16 h-16 bg-purple-100 dark:bg-purple-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
          <i data-feather="clock" class="w-8 h-8 text-purple-600"></i>
        </div>
        <h4 class="text-xl font-semibold text-gray-900 dark:text-white mb-3">24/7 Self Check-In</h4>
        <p class="text-gray-600 dark:text-gray-400 mb-4">
          Arrive at any time that suits you. Our smart lock system works around the clock for your convenience.
        </p>
        <div class="flex items-center justify-center text-sm text-purple-600 dark:text-purple-400">
          <i data-feather="calendar" class="w-4 h-4 mr-2"></i>
          <span>Always Available</span>
        </div>
      </div>
    </div>

    <!-- How It Works -->
    <div class="mt-16">
      <div class="text-center mb-12">
        <h4 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">How It Works</h4>
        <p class="text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
          Getting access to your accommodation is as simple as 1-2-3
        </p>
      </div>

      <div class="grid lg:grid-cols-3 md:grid-cols-1 grid-cols-1 gap-8">
        <!-- Step 1 -->
        <div class="flex flex-col md:flex-row lg:flex-col items-center text-center md:text-left lg:text-center">
          <div class="w-12 h-12 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-lg mb-4 md:mb-0 md:mr-4 lg:mr-0 lg:mb-4 flex-shrink-0">
            1
          </div>
          <div>
            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Complete Online Check-In</h5>
            <p class="text-gray-600 dark:text-gray-400">
              Use our online check-in system to verify your identity and booking details from anywhere.
            </p>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="flex flex-col md:flex-row lg:flex-col items-center text-center md:text-left lg:text-center">
          <div class="w-12 h-12 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-lg mb-4 md:mb-0 md:mr-4 lg:mr-0 lg:mb-4 flex-shrink-0">
            2
          </div>
          <div>
            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Receive QR Access Code</h5>
            <p class="text-gray-600 dark:text-gray-400">
              Get your unique QR code that will be activated 2 hours before your scheduled check-in time.
            </p>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="flex flex-col md:flex-row lg:flex-col items-center text-center md:text-left lg:text-center">
          <div class="w-12 h-12 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-lg mb-4 md:mb-0 md:mr-4 lg:mr-0 lg:mb-4 flex-shrink-0">
            3
          </div>
          <div>
            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Scan & Enter</h5>
            <p class="text-gray-600 dark:text-gray-400">
              Simply scan your QR code at the smart lock to unlock your accommodation instantly.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="relative md:py-24 py-16 overflow-hidden">
  <!-- <app-top-destinations></app-top-destinations> -->

  <div class="container relative">
    <div class="grid grid-cols-1 pb-8 text-center">
      <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Popular Destinations</h3>
      <p class="text-slate-400 max-w-xl mx-auto">Explore our most sought-after locations for short-term stays</p>
    </div>

    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
      <div *ngFor="let item of package | slice:0:6" class="group rounded-md shadow dark:shadow-gray-700">
        <app-grid-data [packageData]="item"></app-grid-data>
      </div>

    </div>

    <div class="mt-6 text-center">
      <a [routerLink]="'/grid'" class="text-slate-400 hover:text-red-500 inline-block">
        {{ 'INDEX1.SEE_MORE' | translate }} <i class="mdi mdi-arrow-right align-middle"></i>
      </a>
    </div>
  </div>

  <app-about></app-about>
  <app-client></app-client>
  <app-blog></app-blog>
</section>

<app-footer></app-footer>
<app-switcher></app-switcher>
